import type { ReactNode } from 'react';

import { cn } from '../../ui/utils';

export interface Definition {
  term: string;
  detail: ReactNode;
}

const COLUMNS = { 1: 'md:grid-cols-1', 2: 'md:grid-cols-2', 3: 'md:grid-cols-3' } as const;

export function DefinitionList(props: { items: Definition[]; columns?: 1 | 2 | 3 }): ReactNode {
  return (
    <dl className={cn('grid grid-cols-1 gap-x-8 gap-y-4', COLUMNS[props.columns ?? 2])}>
      {props.items.map((item) => (
        <div key={item.term} className="flex flex-col gap-1">
          <dt className="text-caption text-muted-foreground">{item.term}</dt>
          <dd className="text-body">{item.detail}</dd>
        </div>
      ))}
    </dl>
  );
}

/** One field per row, label left and value right on the same line, divided from its neighbours --
 *  a record's own fields read top to bottom, unlike `DefinitionList`'s label-above-value grid. */
export function DefinitionRows(props: { items: Definition[] }): ReactNode {
  return (
    <dl className="divide-y">
      {props.items.map((item) => (
        <div
          key={item.term}
          className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0"
        >
          <dt className="text-body-sm text-muted-foreground">{item.term}</dt>
          <dd className="text-body text-right">{item.detail}</dd>
        </div>
      ))}
    </dl>
  );
}
